import { isValidWhatsAppPhone } from '@/utils/sessionWhatsAppDisplay';

const normalizePhoneDigits = (phone: string | null | undefined): string =>
	(phone ?? '').replace(/\D/g, '');

const pickSessionWhatsAppPhone = (
	candidates: Array<string | null | undefined>,
): string | null => {
	for (const candidate of candidates) {
		const digits = normalizePhoneDigits(candidate);
		if (isValidWhatsAppPhone(digits)) return digits;
	}

	for (const candidate of candidates) {
		const digits = normalizePhoneDigits(candidate);
		if (digits) return digits;
	}

	return null;
};

export const resolveSessionWhatsAppContext = (
	session: Sessions.Session,
	options?: {
		fallbackPhones?: string[];
	},
): {
	patientId: string | null;
	patientName: string;
	phone: string | null;
	professionalId: string;
} => {
	const participants = session.participants ?? [];
	const patientParticipant =
		participants.find(
			(entry) =>
				entry.patient_id != null || entry.entity_type === 'PATIENT',
		) ?? participants[0];
	const professionalId =
		session.professional_id ?? session.professional?.id ?? '';

	const phone = pickSessionWhatsAppPhone([
		...(options?.fallbackPhones ?? []),
		...participants.flatMap((entry) => [
			entry.patient?.phone,
			entry.user?.phone_number,
		]),
		session.user?.phone_number,
		patientParticipant?.patient?.phone,
		patientParticipant?.user?.phone_number,
	]);

	const patientName =
		patientParticipant?.patient?.full_name?.trim() ||
		(patientParticipant?.user
			? `${patientParticipant.user.first_name ?? ''} ${(
					patientParticipant.user.last_name ?? ''
			  ).trim()}`.trim()
			: '') ||
		(session.user
			? `${session.user.first_name ?? ''} ${(
					session.user.last_name ?? ''
			  ).trim()}`.trim()
			: '') ||
		'Paciente';

	return {
		patientId:
			patientParticipant?.patient_id ??
			patientParticipant?.patient?.id ??
			null,
		patientName,
		phone,
		professionalId,
	};
};
